/**
 * Frontend admin URL base path.
 *
 * This is INTENTIONALLY OBSCURE. The path is treated as defense-in-depth
 * only — the real gate is Cloudflare Zero Trust (network layer) + TOTP
 * (application layer). Do NOT treat this string as a secret: it appears
 * in browser history, server access logs, dev tools, etc.
 *
 * To rename later: change the literal here, redeploy, update CF Zero
 * Trust path patterns, update bookmarks. Backend API paths
 * (`/api/auth`, `/api/admin`) are UNCHANGED.
 */
export const ADMIN_BASE = "/caldera/px26blr";

// Common derived URLs — use these instead of string-concatenating.
export const ADMIN_LOGIN_URL = `${ADMIN_BASE}/login`;
export const ADMIN_DASHBOARD_URL = ADMIN_BASE;
export const ADMIN_BOOKINGS_URL = `${ADMIN_BASE}/bookings`;
export const ADMIN_CALENDAR_URL = `${ADMIN_BASE}/calendar`;
export const ADMIN_WAITLIST_URL = `${ADMIN_BASE}/waitlist`;
export const ADMIN_PAYMENTS_URL = `${ADMIN_BASE}/payments`;
export const ADMIN_SETTINGS_URL = `${ADMIN_BASE}/settings`;
export const ADMIN_REPORTS_URL = `${ADMIN_BASE}/reports`;
export const ADMIN_MANUAL_BOOKING_URL = `${ADMIN_BASE}/bookings/new`;

export const adminBookingDetailUrl = (id) => `${ADMIN_BOOKINGS_URL}/${id}`;
